import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/ModelSelect/selectedModels.ts";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import "core-js/modules/es.array.some.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import { createEvent, createStore } from 'effector';
export var selectedModels = createSelectedModel();

function createSelectedModel() {
  var addModel = createEvent({
    name: "addModel",
    sid: "p9alz1"
  });
  var replaceModel = createEvent({
    name: "replaceModel",
    sid: "ch8dio"
  });
  var reset = createEvent('reset', {
    name: "reset",
    sid: "gojj9g"
  });
  var models$ = createStore(null, {
    name: "models$",
    sid: "y0izvv"
  }).on(addModel, function (list, newModel) {
    if (list && list.some(function (model) {
      return (model === null || model === void 0 ? void 0 : model.viewerId) === newModel.viewerId;
    })) {
      return list;
    }

    return list ? [].concat(_toConsumableArray(list), [newModel]) : [newModel];
  }).on(replaceModel, function (list, newModel) {
    return list ? list.filter(function (model) {
      return model.viewerId !== newModel.viewerId;
    }) : list;
  }).reset(reset);
  return {
    models$: models$,
    addModel: addModel,
    replaceModel: replaceModel,
    reset: reset
  };
}